import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"

export const downloadResourcesTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "downloadResources",
    onDone: {
      target: "#StudyPlan.edit_plan.idle"
    },
    onError: {
      // TODO: error handling
    }
  }
}
